<template>
  <v-container style="max-width: 100%">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-img class='align-center' :src="require('@/assets/images/sub.jpg')">
          <div class="text-center white--text py-5">
            <div class="text-sm-h3 pt-5 font-weight-bold" style="font-size: 1.5rem">인피니티 소식</div>
            <div class="text-sm-h5 py-5" style="font-size: 1.0rem">인피니티투자자문의 소식을 알려드립니다.</div>

          <!-- <div class='text-center white--text'><span class="sub_01">인피니티투자자문의 소식을 알려드립니다.</span></div>
          <div class='text-center white--text'>
            <span class="sub_02">다양한 소식으로 고객님 곁에 다가가겠습니다.</span><br>
            <span>인피니티투자자문의 새롭게 올라온 소식을 알려드립니다.</span>-->
          </div>
        </v-img>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" class="pa-0">
        <v-tabs
          v-model="model"
          centered
          slider-color="white"
          color="white"
          background-color="red darken-4"
          dark
          active-class="white red--text"
          replace
        >
          <v-tab
            v-for="(menu, i) in menus"
            :key="i"
            :href="`#tab-${i+1}`"
          >
            {{menu.title}}
          </v-tab>
        </v-tabs>

        <v-container>
          <div :class="$vuetify.breakpoint.mobile ? 'col-12 pa-0' : 'col-8 mx-auto'">
            <v-tabs-items v-model="model">
              <v-tab-item
                v-for="(menu, i) in menus"
                :key="i"
                :value="`tab-${i+1}`"
              >
                <v-card flat>
                  <v-simple-table>
                    <thead>
                      <tr class="blue-grey darken-1">
                        <th class="text-center white--text" style="width:100px">번호</th>
                        <th class="text-center white--text">제목</th>
                        <th class="text-center white--text" style="width:100px">첨부파일</th>
                        <th class="text-center white--text" style="width:150px">등록일</th>
                      </tr>
                    </thead>
                    <tbody v-if="viewDataList.length > 0" class="text-center">
                      <tr v-for="(item, i) in viewDataList" :key="i">
                        <td>{{ item.BSNO }}</td>
                        <td class="text-left" @click="popupDialog(item)"><span v-html="item.TITLE_VC"></span></td>
                        <td><a :href="`http://www.infinityasset.com/upload/2009_News/${item.SFILE_VC}`" v-if="item.OFILE_VC" ><v-icon>mdi-paperclip</v-icon></a></td>
                        <td>{{ item.WDATE_VC.substring(0, 10) }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div class="text-center">
                    <v-pagination
                      v-model="page"
                      :length="pageing"
                      prev-icon="mdi-menu-left"
                      next-icon="mdi-menu-right"
                    ></v-pagination>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="700"
      width="600"
    >
      <v-card class="mx-auto">
        <v-container fluid>
          <v-card-text>
            <v-row>
              <v-col cols="2">제목</v-col>
              <v-col class="10"><span v-html="title"></span></v-col>
            </v-row>
            <v-row>
              <v-col cols="2">첨부파일</v-col>
              <v-col cols="10"><a v-if="file_url" :href="file_url">{{file}}<v-icon>mdi-content-save</v-icon></a></v-col>
            </v-row>
            <v-row>
              <v-col cols="2">등록일</v-col>
              <v-col cols="10">{{ regdate }}</v-col>
            </v-row>
            <v-row class="pt-4">
              <v-textarea
                outlined
                solo
                label="Solo textarea"
                :value="content"
                hide-details
                :readonly="true"
                :auto-grow="true"
              ></v-textarea>
            </v-row>
          </v-card-text>
        </v-container>
        <v-card-actions class="justify-center">
          <v-btn color="gray" @click="dialog=false">목록</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  //import board from "@/assets/json/board.json";
  export default {
    data: () => ({
      dialog: false,
      isMore: false,
      title: '',
      file: '',
      file_url: '',
      regdate: '',
      content: '',
      page: 1,
      orgDataLists: [],
      viewDataList: [],
      dataLists: [],
      pageing: 0,
      model: '',
      menus: [
        { title: '인피니티 소식', menuno: '05', page: 'tab-1' },
      ],
      boardlist: [] //board
    }),
    watch: {
      page: {
        handler() {
          this.goPage()
        }
      }
    },
    /*
    computed: {
      boardlist() {
        return board.map((items) => {
          return items;
        });
      },
    },
    */
    created() {
      //this.viewDataList= this.dataLists;
    },
    mounted() {
      this.$http.get(`${process.env.VUE_APP_API_URL}/getNews`)
        .then((response) => {
          if(response.status == 200) {
            this.dataLists = response.data;
            this.viewDataList= this.dataLists;

            this.model = this.$route.query.page;
            this.pageing = Math.ceil(this.dataLists.length / 10);
            this.goPage();

            if(this.$route.query.row) {
              const found = this.dataLists.find(element => element.BSNO == this.$route.query.row);
              this.popupDialog(found);
            }
          } else {
            this.dataLists = [];
          }
        })
        .catch(error => {
          console.error("API 요청 실패:", error);
          this.dataLists = [];
        });
    },
    methods: {
      goPage() {
        this.viewDataList = [];

        for(let i=0; i < this.dataLists.length; i++) {
          if(this.page == 1) {
            if(10 > i) {
              this.viewDataList.push(this.dataLists[i]);
            }
          } else {
            let start = Number(this.page-1) * 10;
            let end = Number(this.page) * 10;
            if(start <= i && end > i) {
              this.viewDataList.push(this.dataLists[i]);
            }
          }
        }
      },
      popupDialog(item) {
        this.file_url = "";
        this.dialog = true;
        this.title = item.TITLE_VC;
        this.file = item.OFILE_VC;

        if(item.SFILE_VC) {
          this.file_url = "http://www.infinityasset.com/upload/2009_News/"+item.SFILE_VC;
        }
        this.regdate = item.WDATE_VC.substring(0, 10);
        this.content = item.CONTENT_VC;
      }
    }
  }
</script>

<style>
.v-data-table-header{
  background: #eeeeee;;
}

.v-tabs{
  margin-bottom: 80px;

}


.v-tab.v-tab{
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0rem;
  padding: 0 60px;
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled{
  color: #ffffff !important;
}

.sub_01{
  font-size:3.375rem ;
  font-weight: 700;
}
.sub_02{
  font-size:1.625rem;
}

a { text-decoration:none !important }
a:hover { text-decoration:none !important }

</style>



